import { createAction, props } from '@ngrx/store';
import { BizCategory } from '../../models/biz-category';

// Action to load community Category
export const loadBizCategory = createAction(
  '[Product] Load Biz Category'
);

// Action to handle successful loading of community Category data
export const loadBizCategorySuccess = createAction(
  '[Product] Load Biz Category Success',
  props<{ bizCategory: BizCategory[] }>() // Correct type reference, array of 'Category' objects
);

// Action to handle failure in loading community Category data
export const loadBizCategoryFailure = createAction(
  '[Product] Load Biz Category Failure',
  props<{ error: any }>()
);
